export default __webpack_public_path__ + "static/media/vaec.5c7b7c39.png";